<template>
	<div class="card">
        <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
          	<div class="text-muted fs-19 d-flex justify-content-start">
		   		<strong>Receita</strong>
		  	</div>
		  	<bsh-dropdown-nav
		  		id="dropdownReceita"
		  		:tabs="tabs"
		  		:ativo="2"
		  		@navChanged="ChangeChart">
		  	</bsh-dropdown-nav>
        </div>
        <div class="card-body">
			<chart  
				:data="config.data"
				identify="chartReceita"
				width="100%"
				height="40"
				:key="receitaChartKey">
			</chart>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['date'],
		data(){
			return {
				data: [],
				dados: [],
				label: [],
				datasets: [],
				tabs: [
		            {
		              	label: 'Semana',
		              	field: 'semanat',
		            },
		            {
		              	label: 'Mês',
		              	field: 'mest'
		            },
		            {
		            	label: 'Ano',
		              	field: 'anot',
		            },
				],
				config: {
					'data': [] 
				},
				receitaChartKey: 1
			}
		},
		created(){
			this.label = this.setLabelAno();
			this.getDados();
		},
		methods: {
			getDados(){
				axios.get(this.$url+'/api/adm/receita/chart?data='+this.date)
	            .then(response => {
	            	this.dados = response.data
	            	this.ChangeChart('anot');
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			},
			ChangeChart(chartPeriod){
				this.datasets = [];
				if(chartPeriod == 'anot'){
					this.label = this.setLabelAno();
					this.datasets.push(this.dados.receita_mes_ano);
				}
				if(chartPeriod == 'mest'){
					this.label = this.setLabelMes();
					this.datasets.push(this.dados.receita_dia_mes);
				}
				if(chartPeriod == 'semanat'){
					this.label = this.setLabelSemana();
					this.datasets.push(this.dados.receita_dia_semana);
				}
				this.setConfigData();
				this.receitaChartKey += 1;
			},
			setLabelMes(){
				var date = new Date();
				var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
				var dia_fim = ultimoDia.getDate();
				var result = [];
				for(var i=1; i<=dia_fim; i++){
					result.push(String(i));
				}	
				return result;
			},
			setLabelAno(){
				return [
					'Jan',
					'Fev',
					'Mar',
					'Abr',
					'Mai',
					'Jun',
					'Jul',
					'Ago',
					'Set',
					'Out',
					'Nov',
					'Dez'
				];
			},
			setLabelSemana(){
				return [
					'Dom',
					'Seg',
					'Ter',
					'Qua',
					'Qui',
					'Sex',
					'Sab'
				];
			},
			setConfigData(){
				this.config['data'] = {
				 	type: 'bar',
				  	data: {
				    	labels: this.label,
				    	datasets: this.datasets
				  	},
				  	options: {
				    	scales: {
				      		xAxes: [
				      			{
				        			time: {
				          				unit: 'date'
				        			},
				        			gridLines: {
				          				display: false
				        			},
				        			ticks: {
				          				maxTicksLimit: 32
				        			}
				      			}
				      		],
				      		yAxes: [{
				        		ticks: {
				          			min: 0,
				          			maxTicksLimit: 5,
				          			callback: function(value) {
									    return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
									}
				        		},
				        		gridLines: {
				          			color: "rgba(0, 0, 0, .125)",
				        		}
				      		}],
				    	},
				    	legend: {
				      		display: false
				    	},
				    	tooltips: {
							callbacks: {
								label: function(tooltipItem, data) {
							    	return tooltipItem.yLabel.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
							  	}
							}
						}
				  	}
				}
			}
		}
	}
</script>